import React, { Dispatch, useLayoutEffect, useRef, useState } from 'react';
import { DebouncedFunc } from 'lodash';
import '../App.css';
import NodeTurn from './NodeTurn'
import { IInject, IScenario } from '../interfaces';
import withScrolling, { createHorizontalStrength, createVerticalStrength } from 'react-dnd-scrolling';
const ScrollingComponent = withScrolling('div');
const hStrength = createHorizontalStrength(500);
const vStrength = createVerticalStrength(500);

interface NodeTimelineProps {
    updateShowHide: Dispatch<any>;
    setInjectComponents: Dispatch<any>;
    injectComponents: IInject[];
    showNodeTimeline: string;
    showNodeInjMenu: string;
    showMiniTimeline: string;
    setInjectItem: Dispatch<any>;
    injectItem: IInject;
    gameTimeInterval: number;
    zoomLevel: number;
    draggedDot: string;
    setDraggedDot: Dispatch<any>;
    nodeTurnHeight: string;
    setNodeTurnHeight: Dispatch<any>;
    selectedScenario: IScenario;
    setSelectedScenario: Dispatch<any>; 
    dotDragging: boolean;
    setDotDragging: Dispatch<any>;
    saveScenario: (i: IInject[]) => Promise<void>;
    onChangeSave: DebouncedFunc<any>;
    setNodeSaving: Dispatch<any>; 
    nodeSaving: { injectId: string, nodeId: string, saving: boolean };
    setNodeTurnHeightArray: Dispatch<any>;
    nodeTurnHeightArray: any;
  }

const NodeTimeline: React.FC<NodeTimelineProps> = ({ setInjectComponents, injectComponents, updateShowHide, showNodeTimeline, showNodeInjMenu, setInjectItem, injectItem, gameTimeInterval, zoomLevel, draggedDot, setDraggedDot, nodeTurnHeight, setNodeTurnHeight, selectedScenario, setSelectedScenario, dotDragging, setDotDragging, saveScenario, nodeSaving, setNodeSaving, onChangeSave, setNodeTurnHeightArray, nodeTurnHeightArray }) => {
    const nodeWrapperUI = useRef<HTMLDivElement>(null);
    const [recentlyAddedTurn, setRecentlyAddedTurn] = useState<number>(-1);
    
    let turnWrapper: string;
    let turnTimelineLeft: string = '';
    let turnWidth: number = 0;
    if (zoomLevel === 1) {
        turnWidth = 520;
    }
    if (zoomLevel === 2) {
        turnWidth = 325;
    }
    if (zoomLevel === 3) {
        turnWidth = 214;
    }

    turnWrapper = (injectItem.turnLength + 1) * turnWidth + 300 + 'px'
    const disabledTurnWrapper = injectItem.turnLength * turnWidth + 400 + 'px'

    if (showNodeInjMenu === 'show') {
        turnTimelineLeft = 'timeline-left'
    }

    const addTurn = () => {
        let turnLengths: number[] = []
        for (let i = 0; i<injectComponents.length; i++) {
            turnLengths.push((injectComponents[i].startTurn + 1) + injectComponents[i].turnLength)
        }

        let maxTurn = 1;

        if ((injectItem.turnLength + 1) > Math.max(...turnLengths)) {
            maxTurn = (injectItem.turnLength + 1);
        } else {
            maxTurn = Math.max(...turnLengths);
        }

        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, turnLength: inject.turnLength + 1 };
            } else {
                return structuredClone(inject);
            }
        }));

        setInjectItem({
            ...injectItem,
            turnLength: (injectItem.turnLength + 1),
            isChanged: true
        });

        setSelectedScenario({
            ...selectedScenario,
            gameTimeInterval: maxTurn
        });

        setRecentlyAddedTurn(injectItem.turnLength + 1);
    }

    const deleteTurn = (turnNum: number) => {
        injectItem.nodes = injectItem.nodes.map((node) => {
            if (node.turn >= turnNum) {
                node.turn = node.turn - 1;
            }
            return node;
        })

        let turnLengths: number[] = []
        for (let i = 0; i<injectComponents.length; i++) {
            if (injectComponents[i].injectId === injectItem.injectId) {
                turnLengths.push((injectComponents[i].startTurn + 1) + injectComponents[i].turnLength - 1)
            } else {
                turnLengths.push((injectComponents[i].startTurn + 1) + injectComponents[i].turnLength)
            }
        }

        let maxTurn = Math.max(...turnLengths);
        setInjectItem({
            ...injectItem,
            turnLength: (injectItem.turnLength - 1),
            length: (injectItem.turnLength - 1)
        });

        setSelectedScenario({
            ...selectedScenario, 
            gameTimeInterval: maxTurn
        });
          
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                let newLength = inject.turnLength - 1;
                return { ...inject, turnLength: newLength, length: newLength };
            } else {
                return structuredClone(inject);
            }
        }));
    }

    const showDeleteBtn = (turnNum: number) => {
        if (selectedScenario.published) return

        const turnHasNodes = injectItem.nodes.some(node => node.turn === turnNum)
        const hasFutureNodes = injectItem.nodes.some(node => node.turn > turnNum)

        if (turnHasNodes || hasFutureNodes) return;

        return <img className="delete-turn" src="img/trash-can.svg"
            onClick={(evt) => deleteTurn(turnNum)} alt="trash"/>
    }

    useLayoutEffect(() => {
        if (recentlyAddedTurn > -1) {
            nodeWrapperUI?.current?.parentElement?.scrollTo({
                left: nodeWrapperUI.current.scrollWidth,
                behavior: 'smooth',
            });
            setRecentlyAddedTurn(-1);
        }
    }, [recentlyAddedTurn])
        
    return (
        <ScrollingComponent verticalStrength={vStrength} horizontalStrength={hStrength} className={`node-content ${showNodeTimeline} ${turnTimelineLeft}`}>

            <div className="node-turn-wrapper1" ref={nodeWrapperUI} style={{'width':turnWrapper, 'height': nodeTurnHeight === '' ? '' : nodeTurnHeight }}>
                { selectedScenario.published
                    ? <div className="nodes-unpublished" style={{'width': disabledTurnWrapper, 'height': nodeTurnHeight === '' ? '' : nodeTurnHeight }}></div>
                    : <></>}

                <div className="turn-gutter">
                    <div className="turn-start-scenario">
                        <span>Scenario Start</span>
                    </div>
                </div>

                {Array.from({length: injectItem.turnLength}, (item, index) =>
                    <div key={index} className="node-turn-wrapper">
                        {showDeleteBtn(index+1)}
                        <NodeTurn setSelectedScenario={setSelectedScenario} saveScenario={saveScenario} updateShowHide={updateShowHide} setInjectComponents={setInjectComponents} injectComponents={injectComponents} setInjectItem={setInjectItem} injectItem={injectItem} turn={index+1} zoomLevel={zoomLevel} greedy={false} selectedScenario={selectedScenario} nodeTurnHeight={nodeTurnHeight} setNodeTurnHeight={setNodeTurnHeight} setNodeSaving={setNodeSaving} nodeSaving={nodeSaving} onChangeSave={onChangeSave} nodeTurnHeightArray={nodeTurnHeightArray} setNodeTurnHeightArray={setNodeTurnHeightArray} />
                    </div>
                )}

                { !selectedScenario.published &&
                    <div className="node-turn-wrapper">
                        <NodeTurn updateShowHide={updateShowHide} nodeTurnHeight={nodeTurnHeight} setNodeTurnHeight={setNodeTurnHeight} 
                            saveScenario={saveScenario} selectedScenario={selectedScenario} setSelectedScenario={setSelectedScenario}
                            setInjectComponents={setInjectComponents} injectComponents={injectComponents}
                            setInjectItem={setInjectItem} injectItem={injectItem} 
                            turn={injectItem.turnLength + 1} zoomLevel={zoomLevel} greedy={false}
                            setNodeSaving={setNodeSaving} nodeSaving={nodeSaving}
                            onChangeSave={onChangeSave} addTurn={addTurn} nodeTurnHeightArray={nodeTurnHeightArray} setNodeTurnHeightArray={setNodeTurnHeightArray} />
                    </div>
                }
            </div>
        </ScrollingComponent>
    )
}

export default NodeTimeline;